import { render } from "./EditProjectElementForm.vue?vue&type=template&id=27a94676"
import script from "./EditProjectElementForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProjectElementForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/Element/EditProjectElementForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27a94676"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27a94676', __exports__)) {
    api.reload('27a94676', __exports__)
  }
  
  module.hot.accept("./EditProjectElementForm.vue?vue&type=template&id=27a94676", () => {
    api.rerender('27a94676', render)
  })

}


export default __exports__